// @flow

import { Environment } from 'relay-runtime';
import { commitMutation, graphql } from 'react-relay';

const addMutation = graphql`
	mutation BlockAddMutation($input: BlockAddInput!) {
		BlockAdd(input: $input) {
            error
			blockEdge {
				node {
					id
				}
			}
		}
	}
`;

export function commit(environment: Environment, params: any, callback: (error: ?Error, id: ?string) => void) {
	commitMutation(environment, {
		mutation: addMutation,
		variables: {
			input: params,
		},
		onCompleted: response => {
			const {error, userEdge} = response.BlockAdd;
			if (error) {
				callback(error, null);
				return;
			}

			callback(null, userEdge);
		},
		onError: error => {
			console.log('error mutating');
			console.log(error);
			callback(error, null);
		},
	});
}



// WEBPACK FOOTER //
// src/mutations/BlockAddMutation.js